export const mediaQueries = {
  desktop: '@media (min-width: 1026px) and (max-width: 1599px)',
  desktopLarge: '@media (min-width: 1600px) and (max-width: 1919px)',
  desktopXLarge: '@media (min-width: 1920px)',
  tablet: '@media (min-width: 600px) and (max-width: 1025px)',
  mobile: '@media (max-width: 599px)',
};
